'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { forwardRef, useState, useRef, useEffect } from 'react';
import deepEqual from './utils/deepEqual.js';
import HTMLForm from './component/HTMLForm.js';
import FormItem from './component/Item/index.js';
import FormProvider from './component/FormProvider.js';
import FormLabel from './component/Label.js';
import FormError from './component/Error.js';
import validation from './validator/index.js';

var Form = forwardRef(function (_a, ref) {
    var initialValues = _a.initialValues, initialSubmitValues = _a.initialSubmitValues, onSubmit = _a.onSubmit, onSubmitError = _a.onSubmitError, getCurrentValues = _a.getCurrentValues, _b = _a.requestScrollToFirstErrorElement, requestScrollToFirstErrorElement = _b === void 0 ? false : _b, validation = _a.validation, children = _a.children;
    var values = __assign({}, initialValues);
    var formRules = validation ? __assign({}, validation) : {};
    var _c = useState({
        values: values,
        errors: {},
        errorFields: [],
        touched: [],
        formRules: formRules,
        watch: {},
        watchValues: {},
        isSubmited: false,
        isScrollToFirstErrorElement: false,
        onSubmit: onSubmit,
        onSubmitError: onSubmitError,
        getCurrentValues: getCurrentValues,
        initialSubmitValues: initialSubmitValues
    }), formValues = _c[0], setFormValues = _c[1];
    var formValuesRef = useRef();
    var initialSubmitValuesRef = useRef();
    useEffect(function () {
        if (!deepEqual(formValuesRef.current, initialValues)) {
            /*
             * Only set values again if initial values has any changes
             * */
            formValuesRef.current = initialValues;
            setFormValues(function (prevFormValues) {
                var values = __assign({}, initialValues);
                return __assign(__assign({}, prevFormValues), { values: __assign(__assign({}, prevFormValues.initialSubmitValues), values) });
            });
        }
    }, [initialValues]);
    useEffect(function () {
        if (!deepEqual(initialSubmitValuesRef.current, initialSubmitValues)) {
            /*
             * Only set values again if initial submit values has any changes
             * */
            initialSubmitValuesRef.current = initialSubmitValues;
            setFormValues(function (prevFormValues) {
                var values = __assign({}, initialSubmitValues);
                return __assign(__assign({}, prevFormValues), { initialSubmitValues: __assign(__assign({}, prevFormValues.initialSubmitValues), values) });
            });
        }
    }, [initialSubmitValues]);
    return (React__default.createElement(FormProvider, { initialState: formValues },
        React__default.createElement(HTMLForm, { requestScrollToFirstErrorElement: requestScrollToFirstErrorElement, ref: ref }, children)));
});
Form.Item = FormItem;
Form.Label = FormLabel;
Form.Error = FormError;
Form.validator = validation;

export { Form as default };
//# sourceMappingURL=index.js.map
